// extracted by mini-css-extract-plugin
export default {"content":"wJ-z"};